/**
 * Check if the service is started.
 *
 * @returns {Boolean} True if the service is started; false otherwise.
 */
export default function isStarted() {
  return this.isStarted;
}
